import * as React from 'react';
//import BlogPostNewFACompSelectForm from './BlogPostNewFACompSelectForm';
import BlogPostNewFACompSelectFormV2 from './BlogPostNewFACompSelectFormV2';
import BlogPostNewFACompInputFormV2 from './BlogPostNewFACompInputFormV2';
import {FACompBlogContentType, BlogGenericContentType} from '@nls-2022/nls-bll';
import {generateBlogPostContentFromCompBlogPost} from '@nls-2022/nls-bll';
import {BlogPostContentDisplay} from '../BlogPostContentDisplay';

const BlogPostNewFACompForm = () => {
  const [generatedBlogPost, setGeneratedBlogPost] =
    React.useState<FACompBlogContentType>();
  const [generatedBlogPostContent, setGeneratedBlogPostContent] =
    React.useState<BlogGenericContentType>(
      generateBlogPostContentFromCompBlogPost(generatedBlogPost),
    );
  const [initInputForm, setInitInputForm] = React.useState<boolean>(false);

  return (
    <>
      <h2>Blog Select FA Competition</h2>
      <BlogPostNewFACompSelectFormV2
        setGeneratedBlogPost={setGeneratedBlogPost}
        setInitInputForm={setInitInputForm}
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="flex flex-col">
          {generatedBlogPost !== undefined ? (
            <BlogPostNewFACompInputFormV2
              blogPost={generatedBlogPost!}
              initInputForm={initInputForm}
              setInitInputForm={setInitInputForm}
              setGeneratedBlogPostContent={setGeneratedBlogPostContent}
            />
          ) : (
            <></>
          )}
        </div>
        <div className="flex flex-col">
          {generatedBlogPostContent !== undefined ? (
            <BlogPostContentDisplay
              blogPostContent={generatedBlogPostContent!}
            />
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
};

export default BlogPostNewFACompForm;
